"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFCExportApp = void 0;
var React = require("react");
var ifcExportContext_1 = require("../../../context/bim/ifcExportContext");
var filters_1 = require("../../editableList/filters");
var queryStringParser_1 = require("../../editableList/queryStringParser");
var buttons_1 = require("../../buttons");
var riskListToolbar_1 = require("../../editableList/riskListToolbar");
var react_1 = require("react");
var IFCExport = function (props) {
    var _a = __read((0, react_1.useState)(new queryStringParser_1.QueryStringParser(window.location.search ||
        riskListToolbar_1.defaultRiskControlActionFilterParams)), 2), qs = _a[0], setStateQs = _a[1];
    var onFilterChange = function (name, value) {
        qs.set(name, value);
        setStateQs(qs);
    };
    return (React.createElement("div", { className: "IFCExportContainer" },
        React.createElement("div", { className: "header" },
            React.createElement("h4", null, gettext("IFC Export"))),
        React.createElement("div", { className: "mw-650" },
            React.createElement(filters_1.ActionFilter, { filter: props.filter, onChangeHandler: onFilterChange, qs: qs, include_status: true, include_tags: true, include_text: false, include_users: false, include_groups: false, include_matrices: false, include_costs: false, include_reviewers: false, include_review_dates: false, include_unattached: false, include_udf: false }),
            React.createElement("div", { className: "text-right pr-1" },
                React.createElement(buttons_1.PrimaryButton, { onClick: function () { return props.onExportClick(qs); } }, gettext("Generate IFC"))))));
};
var IFCExportApp = function (props) {
    return (React.createElement(ifcExportContext_1.IFCExportContextProvider, { project_id: props.project_id },
        React.createElement(ifcExportContext_1.default.Consumer, null, function (context) {
            return React.createElement(IFCExport, { filter: context.filter, onExportClick: context.onExportClick });
        })));
};
exports.IFCExportApp = IFCExportApp;
